import { ax } from '@src/utils/axios'
import { BASE_API_URL } from '@src/constants'

interface Options {
  id: number,
}

export const apiCrewActivate = ({
  id,
}: Options) => {
  const options = {
    method: 'PUT',
    url: `${BASE_API_URL}/ref/crews/${id}/activate`,
  }
  return ax(options)
}